// extracted by mini-css-extract-plugin
export default {"feefineButton":"feefineButton---Juc1R","cursor":"cursor---kKCkn"};